import React, { useEffect, useState } from "react";

import Dashboard from "./components/Dashboard";
import DocumentsValidated from "./components/DocumentsValidated";
import DocumentsInProgress from "./components/DocumentsInProgress";
import Preferences from "./components/Preferences";
import FormArchive from "../formArchive";
import CreateObject from "../create-object";
import { useLocation, useParams } from "react-router-dom"
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import axios from "axios"
import { Modal, Button, InputGroup, Container, Input, InputGroupAddon, InputGroupText, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { useDispatch, useSelector } from "react-redux";
import { updateTitle } from "../../redux/updatePageHeadeSlice";
import { Tab, Tabs } from "react-bootstrap";

const DraftFormPage = () => {
    const [showPreferences, setShowPreferences] = useState(false);
    const [isdashPrefMinimized, setIsDashPrefMinimized] = useState(false);
    const [modalType, setmodalType] = useState("");
    // const { form_name } = useParams();
    const { pathname } = useLocation()
    const dispatch = useDispatch()
    const history = useHistory()
    const togglePreference = () => {
        setShowPreferences((prev) => !prev);
    };
    const formName = pathname.split('/')

    useEffect(() => {
        dispatch(updateTitle(formName[2]))
    }, [formName])

    return (
        <div className="h-full flex flex-col">
            <DocumentsInProgress />
            {/* <DashboardPreferenceWrapper>
        <Dashboard
          minimized={isdashPrefMinimized}
          setMinimized={setIsDashPrefMinimized}
          togglePreference={togglePreference}
          isActive={!showPreferences}
        />
        <Preferences
          minimized={isdashPrefMinimized}
          setMinimized={setIsDashPrefMinimized}
          togglePreference={togglePreference}
          isActive={showPreferences}
        />
      </DashboardPreferenceWrapper> */}
            {/* <Tabs
                defaultActiveKey="documents"
                id="uncontrolled-tab-example"
                className="mb-3 customtab"
            >
                <Tab eventKey="documents" title="Documents"> */}
            {/* <div className='dropdown-wrap-outer'>
            <div className='dropdown-wrap btns custom-buttons-options'>
              <label onClick={() => history.push("/form/" + form_name + "/form-archive")} className='btn-defult' htmlFor="dropdown-box-input" data-toggle="dropdown-box-outer">Archive</label>
              <label className='btn-defult' htmlFor="dropdown-box-input" data-toggle="dropdown-box-outer" onClick={() => history.push(`/recycledocs2/${form_name}`)}>Recycle</label>
              <label onClick={() => history.push("/form/" + form_name + "/create-object")} className='btn-defult' htmlFor="dropdown-box-input" data-toggle="dropdown-box-outer">Add New Documents</label>
            </div>
          </div> */}
            {/* <DocumentsValidated />
                </Tab>

                <Tab eventKey="drafts" title="Drafts">
                    <DocumentsInProgress />
                </Tab>
            </Tabs> */}

            {/* <Modal isOpen={show} toggle={handleClose} fullscreen={true} size="md">
        <ModalHeader toggle={handleClose}>{modalType === 'archive' ? 'Archive' : 'Add new documents'}</ModalHeader>
        <ModalBody>
          {modalType === 'archive' ? <FormArchive /> : <CreateObject />}
        </ModalBody>
      </Modal> */}
        </div>
    );
};

// const DashboardPreferenceWrapper = styled.div`
//   display: flex;
//   position: relative;
// `;

export default DraftFormPage;
